<template>
    <div>

        <el-tree
                ref="tree"
                :data="treeData"
                lazy
                :load="loadNode"
                :props="defaultProps"
                node-key="i_obj"
                @node-click="handleNodeClick"
                class="trees  video-tree height100"
                accordion
                :highlight-current='true'
                :expand-on-click-node="false">
            <!--      -->
            <!---->
        </el-tree>
    </div>
</template>

<script>
    import * as API from "./../api"
    import {baseerp} from "@/utils/baseUrl";

    export default {
        name: "ProductTree",
        props:{
        },
        components: {},
        data() {
            return {
                baseerp:'',
                defaultProps: {
                    children: 'children',
                    label: 'label',
                    isLeaf: 'isLeaf',
                    value:'i_obj'
                },
                treeData:[],
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    this.onResize(n);
                },
                deep:true,
            },
    },

        activated(){
            this.onResize();
        },
        mounted() {

            this.baseerp=baseerp;
            this.$nextTick(()=>{
                this.onResize();
            })
        },
        methods: {
            onResize (n){
                if (n==undefined) n=this.$root.workSize;

                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight= n.h-180
            },
            handleNodeClick(val){
                // console.log(val,'treeData')
                if(val.isLeaf==true){
                    this.$emit('showData',val)

                }
            },
            loadNode(node, resolve){
                // console.log(this.treeData,'treeData');
                let _this=this;
                if (node.level === 0) {
                    let val={
                        i_obj:0,
                        i_level:1,
                        i_state:0,

                    }
                    setTimeout(() => {
                            _this.getProductTree(val,resolve);
                    }, 100)
                }
                if (node.level>=1&&node.data.isLeaf==false){
                        _this.getProductTree(node.data,resolve);
                }
            },
            async getProductTree({i_obj=0,i_state=0},resolve){
                let param = {
                    i_mid: this.mid,
                    i_pid:i_obj,
                    i_state:i_state,
                };
                let res = await API.getProductTree(param);
                if (res.code == 1) {
                    let list=[];
                    if (res.data.length>0){
                        res.data.map(one=>{
                            let hash={
                                label:one.vc_name,
                                i_obj:one.i_id,
                                i_state:one.i_state,
                                // i_pid:one.i_pid,
                                isLeaf: one.haschild==0,
                            };
                            list.push(hash);
                        })
                    }
                    return resolve(list);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    /deep/.el-tree-node__label{
        width: 100%;
        overflow: hidden;
        text-overflow: ellipsis;
    }
</style>